import type { SerializedBlockNode } from '@payloadcms/richtext-lexical';
import type { MediaBlock as MediaBlockProps } from '@/payload-types';

import { MediaBlockComponent } from '@/payload/blocks/media/components/component';

export const MediaBlockJSXConverter = {
  mediaBlock: ({ node }: { node: SerializedBlockNode<MediaBlockProps> }) => {
    if (node.fields.blockType === 'mediaBlock') {
      return <MediaBlockComponent {...node.fields} />;
    }
    return null;
  },
};
